import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  overflow: hidden;
  height: 22px;
  margin-bottom: 10px;
`;

export const Rail = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  gap: 6px;
  z-index: 1;
`;

export const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  height: 22px;
  flex-shrink: 0;
  white-space: nowrap;
  background-color: ${({ theme }) => theme.backgroundLighter};
  color: ${({ theme }) => theme.textDark};
  border-radius: 20px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
`;

export const OverflowCount = styled.span`
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  height: 22px;
  align-items: center;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.51) 1%,
    rgba(255, 255, 255, 1) 15%,
    rgba(255, 255, 255, 1) 100%
  );
  white-space: nowrap;
  color: ${({ theme }) => theme.textDark};
  font-size: 11px;
  font-weight: 600;
  z-index: 2;
  padding-left: 20px;
`;
